// Alphazer / alpha controller
import { FdmPlugin, FdmPluginInterface } from './plugins';

export class ImagesAlphaController extends FdmPlugin implements FdmPluginInterface {

    // required name identifier
    static meta = {
        label: 'PLUGINS.IMAGES_ALPHA_CONTROLLER.LABEL',
        name: 'images-alpha-controller',
        translator: 'PLUGINS.IMAGES_ALPHA_CONTROLLER',
        tooltip: 'PLUGINS.IMAGES_ALPHA_CONTROLLER.TOOLTIP',
        icon: 'lightbulb-on',
        shortcut: false,

        category: FdmPlugin.category.debug,
        cardinality: FdmPlugin.cardinality.one,
        types: [ FdmPlugin.types.transformController ],
        ds_types: [ FdmPlugin.ds_types.geotif ]
    };

    // our controls
    controls:any = {
        alpha: { value:0.5, type:'slider', min:0.1, max:1, step:0.01 }
    }

    // original alpha value
    originalAlpha = 1;

    objectInjected() {
        this.name = 'Alphazed';
        this.originalAlpha = this.object.alpha;
    }

    refresh( newvalue = null, section:any = null ) {

        // check in with mama
        super.refresh ( newvalue, section );
        
        this.object.alpha = this.controls.alpha.value;
    }

    reset() {
        this.object.alpha = this.originalAlpha;
    }
}


